import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from '@mui/material';
import CustomSlider from '../CustomSlider/CustomSlider';
const emotions = [
    {
        icon: _jsx("span", { children: "\uD83D\uDE15" }),
        label: 'Needs Rework',
    },
    {
        icon: _jsx("span", { children: "\uD83D\uDE10" }),
        label: 'Can do Better',
    },
    {
        icon: _jsx("span", { children: "\uD83D\uDE0A" }),
        label: 'Good',
    },
];
const SliderEmotions = ({ value, setValue, editable, }) => {
    return (_jsxs(Stack, Object.assign({ flexGrow: 1 }, { children: [_jsx(Stack, Object.assign({ direction: "row", alignItems: "center", justifyContent: "space-around" }, { children: emotions.map((item, index) => (_jsxs(Box, Object.assign({ sx: {
                        textAlign: 'center',
                        width: '90px',
                        height: '74px',
                    } }, { children: [_jsx(Typography, Object.assign({ fontSize: 40 }, { children: item.icon })), _jsx(Typography, Object.assign({ variant: "subtitle2", sx: { marginTop: '12px' } }, { children: item.label }))] }), index))) })), _jsx(CustomSlider, { value: value, setValue: setValue, editable: editable })] })));
};
export default SliderEmotions;
